export default "__VITE_ASSET__CmL1NsWo__"